/**
 * Gets the base URL for the application from environment variables
 * @returns The base URL string
 */
export function getBaseUrl() {
	// If running in the browser, use the current origin to support multiple domains
	if (typeof window !== "undefined") {
		return window.location.origin;
	}

	// Server-side: use the configured site URL
	if (process.env.NEXT_PUBLIC_SITE_URL) {
		return process.env.NEXT_PUBLIC_SITE_URL;
	}

	return `http://localhost:${process.env.PORT ?? 3000}`;
}
